import { HStack, Text, Tag, TagLeftIcon, VStack, Badge } from '@chakra-ui/react'
import { FiMail } from 'react-icons/fi';
import { IApiContactResponse } from "../../models/api/contact/IApiContactResponse";
import './AutocompleteHit.css';

export interface IAutocompleteContactHitProps {
    item: IApiContactResponse;
    components: any;
    onClick?(): void;
}

export const AutocompleteContactHit = ({ item, components, onClick }: IAutocompleteContactHitProps) => (
    <div onClick={onClick}>
        <div className="aa-ItemContent">
            {/* 
            <div className="aa-ItemIcon">
                <img src={""} alt={""} width="40" height="40" />
            </div>
            */}
            <div className="aa-ItemContentBody">
                {(item.name && (
                <>
                    <div className="aa-ItemContentDescription">
                        <strong><components.Highlight hit={item} attribute="name" /></strong>
                    </div>
                    {
                        (!item.firstName && item.salutation && item.lastName && (
                            <div className="aa-ItemContentDescription">
                                {item.salutation    ? `${item.salutation} ` : ``}
                                {item.title         ? `${item.title} ` : ``}
                                {item.lastName      && (<><components.Highlight hit={item} attribute="lastName" /><span>&nbsp;</span></>)}
                            </div>
                        ))
                    }
                    {
                        (item.firstName && item.lastName && (
                            <div className="aa-ItemContentDescription">
                                {item.title         ? `${item.title} ` : ``}
                                {item.firstName     && (<><components.Highlight hit={item} attribute="firstName" /><span>&nbsp;</span></>)}
                                {item.lastName      && (<><components.Highlight hit={item} attribute="lastName" /><span>&nbsp;</span></>)}
                            </div>
                        ))
                    }
                </>
                )) || (
                <>
                    <div className="aa-ItemContentDescription">
                        <strong>
                            {
                                (!item.firstName && item.salutation && item.lastName && (
                                    <>
                                        {item.salutation    ? `${item.salutation} ` : ``}
                                        {item.title         ? `${item.title} ` : ``}
                                        {item.lastName      && (<><components.Highlight hit={item} attribute="lastName" /><span>&nbsp;</span></>)}
                                    </>
                                ))
                            }
                            {
                                (item.firstName && item.lastName && (
                                    <>
                                        {item.title         ? `${item.title} ` : ``}
                                        {item.firstName     && (<><components.Highlight hit={item} attribute="firstName" /><span>&nbsp;</span></>)}
                                        {item.lastName      && (<><components.Highlight hit={item} attribute="lastName" /><span>&nbsp;</span></>)}
                                    </>
                                ))
                            }
                        </strong>
                    </div>
                </>
                )}
                <div className="aa-ItemContentDescription">
                    <components.Highlight hit={item} attribute="email" />
                </div>
            </div>
        </div>
    </div>
);

export const AutocompleteContactHitxxx = ({ item, components, onClick }: IAutocompleteContactHitProps) => (
    <div className="aa-ItemContent"
        onClick={onClick}
        style={{ 
            backgroundColor: "#FFFFFF",
            display: 'flex',
            flexDirection: 'column'
        }}
    >
        {item.name && (
            <div className="aa-ItemTitle">
                {item.name}
            </div>
        )}
        {(item.firstName || item.salutation) && item.lastName && (
            <div>
                {`
                    ${item.salutation ? item.salutation + " " : ""}
                    ${item.title ? item.title + " " : ""}
                    ${item.firstName ? item.firstName + " " : ""}
                    ${item.lastName}`
                }
            </div>
        )}
        <div className="aa-ItemTitle">
            <components.Highlight hit={item} attribute="email" />
        </div>
    </div>
);

export const AutocompleteContactHitxx = ({ item, components, onClick }: IAutocompleteContactHitProps) => (
<VStack spacing="1" align="start" onClick={onClick}> 
        {item.name.length > 0 && (
            <Text fontWeight="medium" fontSize={{ base: "sm" }}>
                {item.name}
            </Text>
        )}
        {item.firstName.length > 0 && item.lastName.length > 0 && (
            <Text color="muted" fontSize={{ base: "sm" }}>
                {`${item.firstName} ${item.lastName}`}
            </Text>
        )}
        <HStack>
            <Tag variant="outline" colorScheme="black" w="full" fontSize={{ base: "xs" }} pl="0" py="2">
                <TagLeftIcon as={FiMail} />
                {item.email}
            </Tag>
            <Badge colorScheme={'blue'} size={{ base: "xs" }}>BLUE</Badge>,
        </HStack>
    </VStack>
);

export const AutocompleteContactHitx = ({ item: contact, onClick }: IAutocompleteContactHitProps) => (
    <VStack spacing="1" align="start">
        {contact.name.length > 0 && (
            <Text fontWeight="medium" fontSize={{ base: "sm" }}>
                {contact.name}
            </Text>
        )}
        {contact.firstName.length > 0 && contact.lastName.length > 0 && (
            <Text color="muted" fontSize={{ base: "sm" }}>
                {`${contact.firstName} ${contact.lastName}`}
            </Text>
        )}
        <HStack>
            <Tag variant="outline" colorScheme="black" w="full" fontSize={{ base: "xs" }} pl="0" py="2">
                <TagLeftIcon as={FiMail} />
                {contact.email}
            </Tag>
            {([
                <Badge colorScheme={'blue'} size={{ base: "xs" }}>uStrich</Badge>,
                <Badge colorScheme={'yellow'} size={{ base: "xs" }}>AD</Badge>,
                <Badge colorScheme={'purple'} size={{ base: "xs" }}>SharePoint</Badge>,
                <Badge colorScheme={'green'} size={{ base: "xs" }}>BauKG</Badge>,
                <Badge colorScheme={'orange'} size={{ base: "xs", sm: "sm" }}>Benutzer</Badge>,
                <Badge colorScheme={'gray'} size={{ base: "xs" }}>N/A</Badge>
            ][contact.sourceType])}
        </HStack>
    </VStack>
);